import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import ColorPalette from '../../horarios/components/ColorPalette';
import { saveMateriasAction } from '../MateriasAction';

const FormMaterias = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const materiasStore = Redux.useSelector((state) => state.materias);

  const activo = materiasStore.activo;

  const initData = {
    nombre: '',
    referencia: '',
    link: '',
    desc: '',
    color: '#1565C0',
    idEstatus: 1,
    idCarrera: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    referencia: false,
    color: false,
    link: false,
    desc: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [isColor, setIsColor] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(() => setData(values), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveMateriasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idCarrera:
            !data.idCarrera || data.idCarrera === 0 ? null : data.idCarrera,
          idEntidad: entidadesStore.activo.id,
        },
        materiasStore.params,
      );
      if (res && !activo) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        {!activo && (
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <InputLabel id={`label_${CONST.carrera.name}`}>
                {CONST.carrera.label}
              </InputLabel>
              <Select
                id={CONST.carrera.name}
                value={data.idCarrera}
                labelId={`label_${CONST.carrera.name}`}
                label={CONST.carrera.label}
                onChange={(e) =>
                  _handleSetDataField(
                    CONST.carrera.idName,
                    Number(e.target.value),
                  )
                }
              >
                <MenuItem key={`car-00`} value={null}>
                  NINGÚNA
                </MenuItem>
                {entCarrerasStore.all.map((el, index) => {
                  return (
                    <MenuItem key={`carrera-${index}`} value={el.id}>
                      {el.carrera.nombre} ({el.modalidad})
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.referencia.name}
            required
            label={CONST.referencia.label}
            value={data.referencia}
            onChange={(e) =>
              _handleSetDataField(CONST.referencia.name, e.target.value)
            }
            helperText={dataError.referencia ? validMessage.required : null}
            error={dataError.referencia}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.link.name}
            required
            label={CONST.link.label}
            value={data.link}
            onChange={(e) =>
              _handleSetDataField(CONST.link.name, e.target.value)
            }
            helperText={dataError.link ? validMessage.required : null}
            error={dataError.link}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack direction="row" spacing={1}>
            <TextField
              fullWidth
              size="small"
              id={CONST.color.name}
              required
              label={CONST.color.label}
              value={data.color}
              maxLength
              onChange={(e) => {
                if (!e.target.value || e.target.value === '') {
                  return _handleSetDataField(CONST.color.name, '#1565C0');
                }
                _handleSetDataField(CONST.color.name, e.target.value);
              }}
              helperText={dataError.color ? validMessage.required : null}
              error={dataError.color}
              inputProps={{ maxLength: 7 }}
            />
            <Box
              sx={{
                backgroundColor: data.color ?? '#1565C0',
                width: 40,
                height: 40,
                borderRadius: 2,
                color: 'white',
                fontWeight: 'bold',
                fontSize: 18,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                  cursor: 'pointer',
                  border: '2px solid black',
                },
              }}
              onClick={() => setIsColor(!isColor)}
            >
              C
            </Box>
          </Stack>
          {isColor && (
            <ColorPalette
              value={data.color ?? '#1565C0'}
              getColor={(color) => {
                _handleSetDataField(CONST.color.name, color);
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            required
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            disabled={loadingSave}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormMaterias;
